<div class="wrapper">
  <div class="center">
    <sui-loader></sui-loader>
  </div>
</div>
